import {Component, Inject, OnInit} from '@angular/core';
import {BaseCustomDialog} from '../base-custom-dialog';
import {DateTimeHelper, TimePeriodType} from '../../../../helper/date-time.helper';
import {ActionIconHelper} from '../../../../helper/action-icon.helper';
import { ICompanyContacts, IContact } from '../../../../models/leads/leads.model';
import {UserTokenService} from '../../../../services/user-service/user-token.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ACTION_DATA_SERVICE, ActionDataService} from '../../../../services/action/data.service';
import {LEADS_DATA_SERVICE, LeadsDataService} from '../../../../services/leads/leads-data.service';
import {AppointmentsHelper} from '../../../../helper/appointments.helper';

@Component({
  selector: 'fi-negotiation-move',
  templateUrl: './negotiation-move.component.html',
  styleUrls: ['./negotiation-move.component.scss'],
  standalone: false,
})
export class NegotiationMoveComponent extends BaseCustomDialog implements OnInit {
  contactName = '';
  leadId: number;
  selectedTypeId: number;
  readonly dateOptionTypes = DateTimeHelper.datePeriodTypes;

  searchedText = '';
  note = '';
  selectedDate: Date;
  title: string;
  iconUrl = ActionIconHelper.getActionIconUrl('NEGOTIATION_MOVE', false);
  darkIconUrl = ActionIconHelper.getActionIconUrl('NEGOTIATION_MOVE', true);
  submitting: boolean;
  companyContacts: ICompanyContacts[];
  contactToDisplay: IContact;
  appointmentExists = false;
  inValidNote = false;

  constructor(
    private userTokenService: UserTokenService,
    public dialogRef: MatDialogRef<NegotiationMoveComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: { contactName: string, leadId: number, leadTypeId: number, title: string },
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService,
    @Inject(LEADS_DATA_SERVICE) private leadsDataService: LeadsDataService
  ) {
    super(dialogRef);

    this.contactName = dialogData?.contactName || '';
    this.leadId = dialogData?.leadId;
    this.title = dialogData?.title;

    this.leadsDataService.getLeadById(this.leadId).subscribe(({success, data}) => {
      if (success) {
        this.companyContacts = data.CompanyContacts;
        this.contactToDisplay = data.Contact;
      }
    });
  }

  onDateSelect(date: Date, time = false): void {
    this.selectedTypeId = null;

    if (!date) {
      this.selectedDate = null;
      return;
    }

    if (!this.selectedDate) {
      this.selectedDate = date;
    } else if (!time) {
      this.selectedDate.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    } else {
      this.selectedDate.setHours(date.getHours(), date.getMinutes());
    }

    this.selectedDate = new Date(this.selectedDate);

    this.appointmentExists = AppointmentsHelper.getAppointments(this.selectedDate, this.appointmentExists);
  }

  setPeriods($event): void {
    this.selectedTypeId = $event;
    this.selectedDate = DateTimeHelper.getDateAfterPeriod(this.dateOptionTypes.find(item => item.Id === +$event));
    this.appointmentExists = AppointmentsHelper.getAppointments(this.selectedDate, this.appointmentExists);
  }

  onDateOptionSelected(type: TimePeriodType): void {
    this.selectedTypeId = type.Id;
    this.selectedDate = DateTimeHelper.getDateAfterPeriod(type);
    this.appointmentExists = AppointmentsHelper.getAppointments(this.selectedDate, this.appointmentExists);
  }

  async ngOnInit(): Promise<void> {
    const userId = await this.userTokenService.getId();
    AppointmentsHelper.getDbAppointments(this.actionDataService, userId);
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
  }

  get formIsValid(): boolean {
    return !!this.leadId && !!this.selectedDate && !this.submitting && !this.inValidNote;
  }

  inValidMaxLength(): boolean {
    this.inValidNote = this.note.length > 2000;
    return this.inValidNote;
  }

  submit(): void {
    if (this.formIsValid) {
      this.submitting = true;
      this.actionDataService.moveNegotiation(this.leadId, this.note, this.selectedDate)
        .subscribe(({success, data}) => {
          if (success) {
            this.clearClassAndCloseDialog(this.dialogRef, 'remove');
          }

          this.submitting = false;
        });
    }
  }
}
